import { SettingsService } from './settings';
import { LeafletMapSettings } from '../maps/leaflet-map-settings';
import { HereTileServerSettings } from '../maps/here-tile-server-settings';
import * as L from 'leaflet';

export class AppSettingsService implements SettingsService {
  mapSettings: LeafletMapSettings = {
    'homeIcon': L.icon({
      'iconUrl': '/assets/images/map/Red Map Pin.png',
      'iconSize': [48, 48],
      'iconAnchor': [24, 24],
      'popupAnchor': [0, 0]
    }),
    'markerIcon': L.icon({
      'iconUrl': '/assets/images/map/Blue Map Pin.png',
      'iconSize': [48, 48],
      'iconAnchor': [24, 24],
      'popupAnchor': [0, 0]
    }),
    'mapOptions': {
      'center': new L.LatLng(51.5033640, -0.1276250), // needs set during initialization
      'minZoom': 10,
      'maxZoom': 18,
      'zoom': 16,
      'zoomControl': true
    }
  };
  tileServerSettings: HereTileServerSettings = {
    'urlTemplate': `{baseUrl}/{path}/{resource}/{map_id}/{scheme}/{z}/{x}/{y}/{size}/{format}?app_id={app_id}&app_code={app_code}&pois=true`,
    'urlParameters':
      {
        'baseUrl': 'https://2.base.maps.api.here.com',
        'path': 'maptile/2.1',
        'resource': 'maptile',
        'map_id': 'newest',
        'scheme': 'normal.day',
        'size': '256',
        'format': 'png8',
		'app_id': 'G7A9QGKY1eF0Iget4lAf',
		'app_code': '96YP2yRC8iairYGPBmRoRg'
      }
  };
  serviceUrl = 'http://localhost:61927/Service/Call';
}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/lib/services/app-settings.service.ts